import React from 'react';
import { findDOMNode } from 'react-dom'
import $ from 'jquery';
import Slider from 'react-slick';
import Header from '../modules/header';
import axios from 'axios';
import parse from 'html-react-parser';
import { Player } from 'video-react';
import ReactPlayer from 'react-player/lazy'
import styled from "styled-components";
import screenfull from 'screenfull'
import header_background from '../assets/images/yachts/main-banner.jpg';
import bottom_background from '../assets/images/bg/image-13.jpg';

import motoryatch from '../assets/images/Home/Motor yachts.png';
import saillingyatch from '../assets/images/Home/Sailing yachts.png';
import openyatch from '../assets/images/Home/Open yachts.png';
import Catamarans from '../assets/images/Home/Catamarans.png';
import Subtract from '../assets/images/Home/Subtract.png';
import guletsyatch from '../assets/images/Home/Gulet tachts.png';
import bannerarow from '../assets/images/icons/banner-arrow.png';
import btnarow from '../assets/images/icons/button-arrow.png';
import yatchimg from '../assets/images/yachts/image-0.png';
import yatchimg1 from '../assets/images/yachts/image-1.png';
import yatchimg2 from '../assets/images/yachts/image-2.png';
import yatchimg3 from '../assets/images/yachts/image-3.png';
import yatchimg4 from '../assets/images/yachts/image-4.png';
import yatchimg5 from '../assets/images/yachts/image-5.png';
import yatchim from '../assets/images/yachts/img5.jpg';
import butnar from '../assets/images/icons/button-arrow.png';
import vector1 from '../assets/images/icons/vector1.png';
import mapmaker from '../assets/images/icons/map-marker.png';
import playicon from '../assets/images/icons/play.png';
import stopicon from '../assets/images/icons/stop.webp';
import slidermob from '../assets/images/yachts/image-9.png';
import slidermobile1 from '../assets/images/yachts/slider1_mob.png';
import slidermobile2 from '../assets/images/yachts/slider2_mob.png';
import imgslider1 from '../assets/images/yachts/image-32.png';
import imgslider2 from '../assets/images/yachts/nim1.png';
import { Link } from 'react-router-dom';

import 'video-react/dist/video-react.css';
import { CalendarContainer } from 'react-datepicker';

class SimpleSlider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      nav1: null,
      nav2: null,
      message: '',
      home_content: {},
      general_content: {},
      featured_types: [],
      featured_tags: [],
      featured_yachts: [],
      search_text: '',
      SliderIndex: 1,
      home_images: {},
      videoFullScreen: false
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  handleSubmit(event) {
    this.props.history.push({
      pathname: '/search',
      search_text: this.state.search_text,
    });
  }

  componentDidMount() {
    window.scrollTo(0, 0);

    axios
      .get(`${process.env.REACT_APP_API_URL}/content/home.json`)
      .then((response) => {
        // console.log('response.data.yachts', response.data.yachts.length)
        this.setState(
          {
            home_content: response.data.home,
            general_content: response.data.general,
            featured_yachts: response.data.yachts,
            home_images: response.data.home_images,
          },
          () => {
            this.setState({ nav1: this.slider2, nav2: this.slider1 });
          }
        );
        window.scrollTo(0, 0);
      })
      .catch();

    axios
      .get(`${process.env.REACT_APP_API_URL}/yachts.json`)
      .then((response) => {
        this.setState({
          featured_types: response.data.featured_types,
          featured_tags: response.data.featured_tags,
        });
      })
      .catch();

    // scroll doen jquery
    $('.arrow-down a').on('click', function (event) {
      if (this.hash !== '') {
        event.preventDefault();
        var hash = this.hash;
        $('html, body').animate(
          {
            scrollTop: $(hash).offset().top,
          },
          800,
          function () {
            window.location.hash = hash;
          }
        );
      }
    });
    // backto top jquery
    if ($('#back-to-top').length) {
      var scrollTrigger = 100, // px
        backToTop = function () {
          var scrollTop = $(window).scrollTop();
          if (scrollTop > scrollTrigger) {
            $('#back-to-top').addClass('show');
          } else {
            $('#back-to-top').removeClass('show');
          }
        };
      backToTop();
      $(window).on('scroll', function () {
        backToTop();
      });
      $('#back-to-top').on('click', function (e) {
        e.preventDefault();
        $('html,body').animate(
          {
            scrollTop: 0,
          },
          700
        );
      });
    }

    document.addEventListener("fullscreenchange", () => {
      if (!this.isFullScreen()) {
        this.setState({ videoFullScreen: false });
      }
    });
  }
  customPaging(i) {
    return (
      <a>
        <div className="paginationslider">
          {' '}
          <button>
            {' '}
            {this.state.SliderIndex} / {this.state.featured_yachts.length}
          </button>
        </div>
      </a>
    );
  }
  beforeChange(oldIndex, newIndex) { }
  afterChange(i) {
    const { SliderIndex, featured_yachts } = this.state;
    if (i == 0) {
      this.setState({ SliderIndex: 1 });
    } else {
      if (featured_yachts.length - i == 1) {
        this.setState({ SliderIndex: i + 1 });
      } else {
        this.setState({ SliderIndex: i + 1 });
      }
    }
  }

  play() {
    console.log("play full screen");
    this.setState({ videoFullScreen: true }, () => {
      screenfull.request(findDOMNode(this.player));  
    })
  }

  ref = player => {
    this.player = player
  }

  isFullScreen = () => {
    return document.fullscreenElement || document.mozFullScreenElement ||
    document.webkitFullscreenElement || document.msFullscreenElement;;
  }

  render() {
    console.log(this.isFullScreen())
    const tags = this.state.featured_tags;

    const home_images = this.state.home_images;

    const backgroundStyle = {
      backgroundImage: `url(${home_images && home_images.header_image && home_images.header_image.url ? home_images.header_image.url : ''
        })`,
    };
    const bottomBackgroundStyle = {
      backgroundImage: `url(${home_images && home_images.bottom_image && home_images.bottom_image.url ? home_images.bottom_image.url : ''
        })`,
    };
    const { SliderIndex } = this.state;
    let fullScreen = this.state.videoFullScreen;

    let isMobile = (window.innerWidth <= 800)
    const style = {
      minHeight: isMobile ? 'calc(100vw * 1.77)' : 'calc(100vw * 0.5625)',
    }

    const playerStyle = {
      zIndex: fullScreen && 20
    }

    const headerStyle = {
      zIndex: fullScreen && 0
    }

    if (isMobile) {
      var url = fullScreen ? 'https://vimeo.com/475024261' : 'https://vimeo.com/475024302'
    } else {
      var url = fullScreen ? 'https://vimeo.com/475024129' : 'https://vimeo.com/475024094'
    }

    return (
      <div className="open_menudiv">
        <Header style={headerStyle}></Header>

        <div className="hero-slider section home-hero" id="main_sec">
          <div className="hero-item" id="home_bg" style={style}>
            <ReactPlayer 
              ref={this.ref}
              className="video-container video-container-overlay header-video" 
              url={url}
              muted="true" 
              playing="true" 
              loop={true}
              style={playerStyle}

            />
            <PlayButton src={playicon} onClick={() => this.play()}></PlayButton>
            <div className="slider-dark-overlay"></div>
            <div className="container">
              <div className="row">
                <div className="hero-content-wrap col">
                  <div className="hero-content">
                    <div className="slide-txt">
                      <p className="first-line">LUXURY GULET &amp; YACHT CHARTER EXPERTS</p>
                      <h1 className="second-line">
                        {this.state.home_content && this.state.home_content.fields && this.state.home_content.fields.heading}
                      </h1>
                      <p className="third-line">
                        {this.state.home_content && this.state.home_content.fields && this.state.home_content.fields.subheading}
                      </p>
                    </div>
                    <div className="banner-btns">
                      <Link to="/search">
                        <button className="btn btn-theme btn-primary">
                          <span>Explore</span>
                          <img src={btnarow} className="img-responsive btn-arrow" id="fl-rht" alt="button arrow" />
                        </button>
                      </Link>
                      <Link to="/blog">
                        <button className="btn btn-lg btn-theme2">
                          <span>Need Inspiration</span>
                          <img src={btnarow} className="sec_btnarow" id="secbtn-rht" alt="button arrow" />
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="secondary-menu d-none d-sm-block">
                  <nav className="navbar navbar-expand-lg navbar-dark primary-color">
                    <div className="" id="basicExampleNav">
                      <form className="form-inline" onSubmit={this.handleSubmit}>
                        <div className="md-form my-0" id="serch_bar">
                          <input
                            className="form-control mr-sm-2"
                            type="text"
                            placeholder="Search"
                            aria-label="Search"
                            name="search_text"
                            value={this.state.search_text}
                            onChange={this.handleChange}
                          />
                          <i className="fa fa-search"></i>
                        </div>
                      </form>
                    </div>
                    <ul className="navbar-nav mr-auto" id="nav_links_right">
                      {this.state &&
                        this.state.featured_types &&
                        this.state.featured_types.map((type, index) => {
                          return [
                            <li className="nav-item" key={index}>
                              <Link className="nav-link" to={{ pathname: '/search', type_id: type.id }}>
                                <img src={motoryatch} className="img-responsive menu-icon" alt="motor yachts" />
                                {type.name}
                              </Link>
                            </li>,
                          ];
                        })}
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
            <div className="arrow-down">
              <a href="#yachts-grids">
                <p className="scroll-text">Scroll Down</p>
                <img src={bannerarow} className="img-responsive" alt="button arrow" />
              </a>
            </div>
            <div className="social-links-top">
              <ul>
                <li>
                  <a
                    href={
                      this.state.general_content &&
                      this.state.general_content.fields &&
                      this.state.general_content.fields.twitter_link
                    }>
                    <i className="fa fa-twitter"></i>
                  </a>
                </li>
                <li>
                  <a
                    href={
                      this.state.general_content &&
                      this.state.general_content.fields &&
                      this.state.general_content.fields.linkedin_link
                    }>
                    <i className="fa fa-linkedin"></i>
                  </a>
                </li>
                <li>
                  <a
                    href={
                      this.state.general_content &&
                      this.state.general_content.fields &&
                      this.state.general_content.fields.instagram_link
                    }>
                    <i className="fa fa-instagram"></i>
                  </a>
                </li>
                <li>
                  <a
                    href={
                      this.state.general_content &&
                      this.state.general_content.fields &&
                      this.state.general_content.fields.facebook_link
                    }>
                    <i className="fa fa-facebook"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* sec section  */}
        <section id="yachts-grids" className="yachts-grids section fix">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-4 col-md-4 no-padding instagram1">
                <div className="yacht-content" id="norman_content">
                  <Link to={{ pathname: '/search', tag_id: tags && tags[0] !== undefined ? tags[0].id : 0 }}>
                    <div
                      className="slider-dark-overlay2"
                      style={{
                        backgroundImage: `url(${home_images && home_images.section_image_1 && home_images.section_image_1.side.url
                            ? home_images.section_image_1.side.url
                            : yatchimg
                          })`,
                      }}
                    />
                    <div className="img-yacht invisible">
                      <img
                        src={
                          home_images && home_images.section_image_1 && home_images.section_image_1.side.url
                            ? home_images.section_image_1.side.url
                            : yatchimg
                        }
                        alt="yacht"
                      />
                    </div>
                    <div className="yacht-text">
                      <h2>{tags && tags[0] !== undefined ? tags[0].name : 'Search Yachts'}</h2>
                      <p>{tags && tags[0] !== undefined ? tags[0].description : ''}</p>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-lg-8 col-md-8">
                <div className="row">
                  <div className="col-lg-6 col-md-6 no-padding instagram4">
                    <div className="yacht-content" id="norman_content">
                      <Link to={{ pathname: '/search', tag_id: tags && tags[1] !== undefined ? tags[1].id : 0 }}>
                        <div
                          className="slider-dark-overlay2"
                          style={{
                            backgroundImage: `url(${home_images && home_images.section_image_2 && home_images.section_image_2.block.url
                                ? home_images.section_image_2.block.url
                                : yatchimg4
                              })`,
                          }}
                        />
                        <div className="img-yacht invisible">
                          <img
                            src={
                              home_images && home_images.section_image_2 && home_images.section_image_2.block.url
                                ? home_images.section_image_2.block.url
                                : yatchimg4
                            }
                            alt="yacht"
                          />
                        </div>
                        <div className="yacht-text align-bottom">
                          <h2>{tags && tags[1] !== undefined ? tags[1].name : 'Search Yachts'}</h2>
                          <p>{tags && tags[1] !== undefined ? tags[1].description : ''}</p>

                        </div>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 no-padding instagram3">
                    <div className="yacht-content" id="norman_content">
                      <Link to={{ pathname: '/search', tag_id: tags && tags[2] !== undefined ? tags[2].id : 0 }}>
                        <div
                          className="slider-dark-overlay2"
                          style={{
                            backgroundImage: `url(${home_images && home_images.section_image_3 && home_images.section_image_3.block.url
                                ? home_images.section_image_3.block.url
                                : yatchimg4
                              })`,
                          }}
                        />
                        <div className="img-yacht invisible">
                          <img
                            src={
                              home_images && home_images.section_image_3 && home_images.section_image_3.block.url
                                ? home_images.section_image_3.block.url
                                : yatchimg3
                            }
                            alt="yacht"
                          />
                        </div>
                        <div className="yacht-text align-bottom">
                          <h2>{tags && tags[2] !== undefined ? tags[2].name : 'Search Yachts'}</h2>
                          <p>{tags && tags[2] !== undefined ? tags[2].description : ''}</p>

                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6 col-md-6 no-padding instagram5">
                    <div className="yacht-content" id="norman_content">
                      <Link to={{ pathname: '/search', tag_id: tags && tags[3] !== undefined ? tags[3].id : 0 }}>
                        <div
                          className="slider-dark-overlay2"
                          style={{
                            backgroundImage: `url(${home_images && home_images.section_image_4 && home_images.section_image_4.block.url
                                ? home_images.section_image_4.block.url
                                : yatchimg4
                              })`,
                          }}
                        />
                        <div className="img-yacht invisible">
                          <img
                            src={
                              home_images && home_images.section_image_4 && home_images.section_image_4.block.url
                                ? home_images.section_image_4.block.url
                                : yatchimg5
                            }
                            alt="yacht"
                          />
                        </div>
                        <div className="yacht-text align-bottom">
                          <h2>{tags && tags[3] !== undefined ? tags[3].name : 'Search Yachts'}</h2>
                          <p>{tags && tags[3] !== undefined ? tags[3].description : ''}</p>
                          
                        </div>
                      </Link>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 no-padding instagram2">
                    <div className="yacht-content" id="norman_content">
                      <Link to={{ pathname: '/search', tag_id: tags && tags[4] !== undefined ? tags[4].id : 0 }}>
                        <div
                          className="slider-dark-overlay2"
                          style={{
                            backgroundImage: `url(${home_images && home_images.section_image_5 && home_images.section_image_5.block.url
                                ? home_images.section_image_5.block.url
                                : yatchimg4
                              })`,
                          }}
                        />
                        <div className="img-yacht invisible">
                          <img
                            src={
                              home_images && home_images.section_image_5 && home_images.section_image_5.block.url
                                ? home_images.section_image_5.block.url
                                : yatchim
                            }
                            alt="yacht"
                          />
                        </div>
                        <div className="yacht-text align-bottom">
                          <h2>{tags && tags[4] !== undefined ? tags[4].name : 'Search Yachts'}</h2>
                          <p>{tags && tags[4] !== undefined ? tags[4].description : ''}</p>
                          
                          </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Slider section  */}
        <section id="sail-slider" className="section fix sail-slider">
          <div className="container-fluid">
            <div className="HomeSlider">
              <div className="sail-vector-img">
                <img src={vector1} className="img-responsive" alt="vector" />
              </div>
              <div className="row">
                <div className="col-md-3" id="right_sideslider">
                  <div id="slick-pager">
                    {this.state.featured_yachts.length > 0 ? (
                      <div className="slick-pager">
                        <Slider
                          asNavFor={this.state.nav1}
                          ref={(slider) => (this.slider1 = slider)}
                          infinite={false}
                          fade={true}
                          arrows={false}>
                          {this.state.featured_yachts.map((yacht, index) => {
                            return (
                              <div key={index} className="slide_all">
                                <div className="title-head">
                                  <h2 className="title_h2">{this.state.featured_yachts[SliderIndex - 1].name}</h2>
                                  <p className="location2">
                                    <img src={mapmaker} className="img-responsive map-marker" alt="mapmaker" />
                                    {yacht && yacht.sailing_countries && yacht.sailing_countries.map((e) => e.name).join(', ')}
                                  </p>
                                </div>
                                <div className="up-nexttgdgd">
                                  <p className="upnext">Up Next</p>
                                  <div className="next-img">
                                    <img
                                      src={
                                        this.state.featured_yachts[SliderIndex % this.state.featured_yachts.length].main_image
                                          .slider.url
                                          ? this.state.featured_yachts[SliderIndex % this.state.featured_yachts.length].main_image
                                            .slider.url
                                          : slidermob
                                      }
                                      className="img-responsive"
                                      alt="slider1"
                                    />
                                  </div>
                                  <div className="title-location">
                                    <p className="title">
                                      {this.state.featured_yachts[SliderIndex % this.state.featured_yachts.length].name}
                                    </p>
                                    <p className="location">
                                      <img src={mapmaker} className="img-responsive map-marker" alt="mapmaker" />
                                      {yacht &&
                                        yacht.sailing_countries &&
                                        this.state.featured_yachts[
                                          SliderIndex % this.state.featured_yachts.length
                                        ].sailing_countries
                                          .map((e) => e.name)
                                          .join(', ')}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </Slider>
                      </div>
                    ) : null}
                  </div>
                </div>
                {this.state.featured_yachts.length > 0 ? (
                  <div className="col-md-9" id="set_botm">
                    <Slider
                      asNavFor={this.state.nav2}
                      ref={(slider) => (this.slider2 = slider)}
                      slidesToShow={1}
                      swipeToSlide={true}
                      focusOnSelect={true}
                      dots={true}
                      infinite={true}
                      afterChange={(i) => this.afterChange(i)}
                      customPaging={(i) => this.customPaging(i)}
                      beforeChange={(oldIndex, newIndex) => this.beforeChange(oldIndex, newIndex)}>
                      {this.state.featured_yachts.map((yacht, index) => {
                        return [
                          <Link to={'/yacht/' + yacht.id}>
                            <div key={index}>
                              <div className="sail-slider-overlay"></div>
                              <div className="head_slider_mobile">
                                <h3 className="heading_mobile_slider">{yacht.name}</h3>
                                <p className="location">
                                  <img src={mapmaker} className="img-responsive map-marker" alt="mapmaker" />
                                  {yacht && yacht.sailing_countries && yacht.sailing_countries.map((e) => e.name).join(', ')}
                                </p>
                              </div>
                              {/* <div className="video-play2">
                                                        <div id="video_container3">
                                                            <div className="vides" id="vieomob">
                                                                <img className="play_ico" src={playicon} alt="play"/>
                                                            </div>
                                                        </div>
                                                    </div> */}
                              <img
                                id="img_slider_mob"
                                alt=""
                                src={yacht && yacht.main_image.slider.url ? yacht.main_image.slider.url : slidermob}
                                className="img-responsive"
                                alt="slider1"
                              />
                              
                              {
                                yacht.testimonial ? 
                                  <div className="slide-content">
                                    <img src={yacht.testimonial.image.url ? yacht.testimonial.image.url : imgslider1} className="img-responsive" alt="img-responsive"/>
                                    <p>{parse(yacht.testimonial.description)}</p>
                                  </div>
                                :
                                false
                              }
                              
                            </div>
                          </Link>,
                        ];
                      })}
                    </Slider>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </section>

        {/* last section */}
        <section id="browse-yachts" className="browse-yachts section fix" style={bottomBackgroundStyle}>
          <div className="container">
            <div className="row">
              <div className="browse-txt">
                <h1>{this.state.home_content && this.state.home_content.fields && this.state.home_content.fields.bottom_text}</h1>
                <Link to="/search">
                  <button type="submit" className="btn btn-theme btn-primary" id="become_captoin">
                    <span>Find your perfect yacht now</span>
                    <img src={butnar} className="img-responsive btn-arrow" alt="button arrow" />
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </section>

        <a href="#pagetop" id="back-to-top" title="Back to top">
          &uarr;
        </a>
      </div>
    );
  }
}

const PlayButton = styled.img`
  width: 90px;
  z-index: 20;
  position: absolute;
  top: 70%;
  right: 10%;
`;
export default SimpleSlider;
